import { useCallback } from 'react';
import { type Embed as EmbedType } from 'types/capi/content';

import SocialEmbedImpressionEvent from '~/events/SocialEmbedImpressionEvent';
import {
  type SocialEmbedPlacement,
  type SocialEmbedProvider
} from '~/events/SocialEmbedInteractionEvent';
import useImpression from '~/hooks/useImpression';
import useRootData from '~/hooks/useRootData';
import { getEmbedUrl } from '~/hooks/useSocialEmbedClick';
import useUser from '~/hooks/useUser';

const MODULE_TYPE = 'embed';

export default function useSocialEmbedImpression(
  embed: EmbedType,
  provider: SocialEmbedProvider,
  placement: SocialEmbedPlacement,
  modulePosition?: number
) {
  const { isBot } = useRootData();
  const { guestId } = useUser();

  const embedUrl = getEmbedUrl(embed);
  const inModule = placement === 'embed_module';

  const track = useCallback(() => {
    if (!embedUrl) return;

    new SocialEmbedImpressionEvent({
      embedUrl,
      guestId,
      isBot,
      modulePosition: inModule ? modulePosition : undefined,
      moduleType: inModule ? MODULE_TYPE : undefined,
      placement,
      provider
    }).track();
  }, [embedUrl, guestId, inModule, isBot, modulePosition, placement, provider]);

  return useImpression<HTMLDivElement>(track, {
    enabled: Boolean(embedUrl) && !isBot
  });
}
